export function updateSettingsReducer(state, { settings }) {
  return {
    ...state,
    settings
  };
}
